"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var BookmarkAddStackThick = function BookmarkAddStackThick(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "bookmark-add-stack-thick"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.32 0h-10.64c-1.199 0.011-2.169 0.981-2.18 2.179v16.861c0 0 0 0 0 0 0 0.523 0.418 0.949 0.939 0.96l0.001 0c0.162-0.002 0.314-0.046 0.444-0.122l-0.004 0.002 6.080-3.76 6.060 3.76c0.142 0.088 0.315 0.14 0.499 0.14 0 0 0.001 0 0.001 0h-0c0.522-0.011 0.94-0.437 0.94-0.96 0-0 0-0 0-0v0-16.86c0-0 0-0.001 0-0.001 0-1.194-0.951-2.166-2.137-2.199l-0.003-0zM15.62 17.38l-5.14-3.18c-0.138-0.081-0.303-0.129-0.48-0.129s-0.342 0.048-0.485 0.131l0.005-0.002-5.16 3.2v-15.2c0.011-0.168 0.15-0.3 0.319-0.3 0 0 0 0 0.001 0h2.22v4.18c0 0.32 0.26 0.58 0.58 0.58v0h0.74c0.006 0 0.013 0 0.020 0 0.32 0 0.58-0.26 0.58-0.58 0-0 0-0 0-0v0-4.18h6.48c0.177 0 0.32 0.143 0.32 0.32v0z"
  }));
};
var _default = exports["default"] = BookmarkAddStackThick;